import { render, staticRenderFns } from "./AdversaryDetail.vue?vue&type=template&id=c2df7b1c&"
import script from "./AdversaryDetail.vue?vue&type=script&lang=js&"
export * from "./AdversaryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2df7b1c')) {
      api.createRecord('c2df7b1c', component.options)
    } else {
      api.reload('c2df7b1c', component.options)
    }
    module.hot.accept("./AdversaryDetail.vue?vue&type=template&id=c2df7b1c&", function () {
      api.rerender('c2df7b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AdversaryDetail.vue"
export default component.exports